import {
  GETKYCAPPROVEREJECT_SUCCESS,
  GETKYCAPPROVEREJECT_FAILED,
  RESET_GETKYCAPPROVEREJECT,
  LOADING_GETKYCAPPROVEREJECT,
  NETWORK_ERROR_GETKYCAPPROVEREJECT,
} from "../types/index";
import { partnerServices } from "../../config/axios";

const resetGetKycApproveReject = () => {
  return { type: RESET_GETKYCAPPROVEREJECT };
};

const getKycApproveRejects = (userData, authTokenIs) => async (dispatch) => {
  dispatch({ type: LOADING_GETKYCAPPROVEREJECT });
  await partnerServices
    .post("getKycApproveReject", userData, { headers: { AuthToken: authTokenIs } })
    .then((res) => {
      switch (res.data.status) {
        case "success":
          dispatch(getKycApproveRejectSuccess(res.data));
          break;
        default:
          dispatch(getKycApproveRejectfailed(res.data));
          break;
      }
    })
    .catch((err) => {
      dispatch({ type: NETWORK_ERROR_GETKYCAPPROVEREJECT, payload: err });
    });
};
function getKycApproveRejectSuccess(data) {
  return {
    type: GETKYCAPPROVEREJECT_SUCCESS,
    payload: data,
  };
}
function getKycApproveRejectfailed(data) {
  return {
    type: GETKYCAPPROVEREJECT_FAILED,
    payload: data,
  };
}

export { resetGetKycApproveReject, getKycApproveRejects };
